import { ActuationAlarmCondition } from 'sigma-mappings';

const conditionLookup = vm => ([
  {
    id: ActuationAlarmCondition.MORE,
    name: vm.$t('sensors.configuration-dm2.modal.condition.more'),
  },
  {
    id: ActuationAlarmCondition.LESS,
    name: vm.$t('sensors.configuration-dm2.modal.condition.less'),
  },
  {
    id: ActuationAlarmCondition.EQUAL,
    name: vm.$t('sensors.configuration-dm2.modal.condition.equal'),
  },
  {
    id: ActuationAlarmCondition.DIFFERENT,
    name: vm.$t('sensors.configuration-dm2.modal.condition.different'),
  },
  {
    id: ActuationAlarmCondition.MORE_OR_EQUAL,
    name: vm.$t('sensors.configuration-dm2.modal.condition.more-or-equal'),
  },
  {
    id: ActuationAlarmCondition.LESS_OR_EQUAL,
    name: vm.$t('sensors.configuration-dm2.modal.condition.less-or-equal'),
  },
]);

export default conditionLookup;
